export enum ContractInfoEnum {
  PERSONAL = 'Personal',
  BUSINESS = 'Business',
  BUSINESS_LICENSE = 'Business license',
  TRAVEL_LICENSE = 'Travel license',
  ADD_ATTACHMENT = 'Addition attachment',
  ID_CARD_BACK = 'ID card back view',
  ID_CARD_FRONT = 'ID card front view',
  CONTRACT_INFO = 'contract-info',
  REVIEW_CONTRACT = 'review-contract',
  ERROR = 'error',
  SUCCESS = 'success',
  EDIT = 'edit',
}
